import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updateTemplateRes;
export const updateTemplateTodo = createAsyncThunk('updateTemplate', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'edit_certificate_data',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "certificate_data_id": data.id,
                "heading": data.heading,
                "certificate_border": data.certificate_border,
                "border_color": data.border_color,
                "background_img": data.background_img,
                "logo": data.logo,
                "logo_allignment": data.logo_allignment,
                "hod_name": data.hod_name,
                "signature": data.signature,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return updateTemplateRes = res.data
    } catch (error) {
        return updateTemplateRes = error.response.data
    }
})